import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../Styles/ExaminationUpdate.css";
import Loader from "../../Components/Loader";
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function FacultyCreateExamination() {
    const [loading, setLoading] = useState(false);
    const [classes, setClasses] = useState([]);
    const [subjects, setSubjects] = useState([]);
    const [selectedClass, setSelectedClass] = useState("");
    const [filteredSubjects, setFilteredSubjects] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [examName, setExamName] = useState("");
    const [examDate, setExamDate] = useState("");
    const [examTime, setExamTime] = useState("");
    const [examDuration, setExamDuration] = useState("");
    const [examDetails, setExamDetails] = useState("");
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
    const [document, setDocument] = useState("");
    const today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        const token = localStorage.getItem("authToken");
        if (!token) {
            throw new Error("No authentication token found");
        }
        const fetchClassSubjectSemester = async () => {
            try {
                const response = await axios.get(
                    "https://api.uniums.com/api/exam/class-subject-semester-faculty",
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );
                const data = response.data;

                if (data) {
                    setClasses(data.classes || []);
                    setSubjects(data.subjects || []);
                }
            } catch (err) {
                toast.error("Failed to fetch class/subject");
            }
        };

        fetchClassSubjectSemester();
    }, []);

    useEffect(() => {
        if (
            examName &&
            examDate &&
            examTime &&
            examDuration &&
            selectedClass &&
            tableData.length > 0 &&
            examDetails
        ) {
            setIsSubmitDisabled(false);
        } else {
            setIsSubmitDisabled(true);
        }
    }, [examName, examDate, examTime, examDuration, selectedClass, tableData, examDetails]);

    const handleClassChange = (e) => {
        const selected = e.target.value;
        setSelectedClass(selected);
        if (selected) {
            const classSpecificSubjects = subjects.filter((subject) => {
                return true;
            });
            setFilteredSubjects(classSpecificSubjects);
        } else {
            setFilteredSubjects([]);
        }

        setTableData([]);
    };

    const handleSubjectChange = (subject, isChecked) => {
        if (isChecked) {
            setTableData((prev) => [
                ...prev,
                { subject, questionType: "", totalMarks: "" },
            ]);
        } else {
            setTableData((prev) => prev.filter((row) => row.subject !== subject));
        }
    };

    const handleInputChange = (index, field, value) => {
        const updatedTableData = [...tableData];
        updatedTableData[index][field] = value;
        setTableData(updatedTableData);
    };

    const handleRowRemove = (subject) => {
        setTableData((prev) => prev.filter((row) => row.subject !== subject));
    };

    const handleFileInput = (e) => {
        let filedata = e.target.files[0];
        setDocument(filedata)
    }
    const convertTo12HourFormat = (time) => {
        const [hour, minute] = time.split(":");
        const isPM = hour >= 12;
        const twelveHour = isPM ? hour - 12 || 12 : parseInt(hour, 10);
        const amPm = isPM ? "PM" : "AM";
        return `${twelveHour}:${minute} ${amPm}`;
    };
    
    const formattedExamTime = convertTo12HourFormat(examTime);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const token = localStorage.getItem("authToken");
        let formdata = new FormData()
        formdata.append('file', document);
        formdata.append('examName', examName);
        formdata.append('examDate', examDate);
        formdata.append("examTime", formattedExamTime);
        formdata.append('examDuration', examDuration);
        formdata.append('className', selectedClass);
        formdata.append('subjects', JSON.stringify(tableData));
        formdata.append('examDetails', examDetails);

        try {
            const response = await axios.post(
                "https://api.uniums.com/api/exam/update-exam-faculty",
                formdata,
                {
                    headers: { Authorization: `Bearer ${token}` },
                }
            );

            if (response.status === 201) {
                toast.success("Exam details saved successfully");
                setExamName("");
                setExamDate("");
                setExamTime("");
                setExamDuration("");
                setSelectedClass("");
                setTableData([]);
                setExamDetails("");
            }
        } catch (error) {
            console.error("Error saving exam details:", error);
            toast.error("Failed to save exam details");
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <ToastContainer />
            {loading ? (
                <Loader />
            ) : (
                <div className="ExaminationUpdate-container">
                    <div className="ExaminationUpdate-faculty-page">
                        <h1>Create/Update Exam Details</h1>
                        <form id="exam-update-form" className="exam_form" onSubmit={handleSubmit}>
                            <label htmlFor="exam-name">Exam Name: <span>*</span></label>
                            <input
                                type="text"
                                id="exam-name"
                                value={examName}
                                onChange={(e) => setExamName(e.target.value)}
                                placeholder="Enter exam name"
                                required
                            />

                            <label htmlFor="exam-date">Exam Date: <span>*</span></label>
                            <input
                                type="date"
                                id="exam-date"
                                value={examDate}
                                min={today}
                                onChange={(e) => setExamDate(e.target.value)}
                                required
                            />
                             <label htmlFor="exam-time">Exam Time: <span>*</span></label>
                            <input
                                type="time"
                                id="exam-time"
                                value={examTime}
                                onChange={(e) => setExamTime(e.target.value)}
                                required
                            />
                              <label htmlFor="exam-time">Exam Duration: <span>*</span></label>
                            <input
                                type="text"
                                placeholder="30 min, 1 hour, etc."
                                id="exam-duration"
                                value={examDuration}
                                onChange={(e) => setExamDuration(e.target.value)}
                                required
                            />

                            <label htmlFor="class-select">Select Class: <span>*</span></label>
                            <select
                                id="class-select"
                                name="classSelect"
                                value={selectedClass}
                                onChange={handleClassChange}
                                required
                            >
                                <option value="">--Select Class--</option>
                                {classes.map((cls) => (
                                    <option key={cls} value={cls}>
                                        {cls}
                                    </option>
                                ))}
                            </select>

                            {selectedClass && (
                                <div className="ExaminationUpdate-subjects">
                                    <h3>Subjects for {selectedClass}:</h3>
                                    {filteredSubjects.map((subject) => (
                                        <div key={subject} className="ExaminationUpdate-subject-item">
                                            <input
                                                type="checkbox"
                                                id={`subject-${subject}`}
                                                onChange={(e) =>
                                                    handleSubjectChange(subject, e.target.checked)
                                                }
                                                className="exam_checkbox"
                                            />
                                            <label htmlFor={`subject-${subject}`}>{subject}</label>
                                        </div>
                                    ))}
                                </div>
                            )}

                            {tableData.length > 0 && (
                                <div className="ExaminationUpdate-table">
                                    <h3>Selected Subjects</h3>
                                    <div className="faculty-table-container">
                                        <table className="attendance-today-table">
                                            <thead>
                                                <tr>
                                                    <th>Subject</th>
                                                    <th>Question Type <span>*</span></th>
                                                    <th>Total Marks <span>*</span></th>
                                                    <th>Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {tableData.map((row, index) => (
                                                    <tr key={row.subject}>
                                                        <td>{row.subject}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                value={row.questionType}
                                                                onChange={(e) =>
                                                                    handleInputChange(
                                                                        index,
                                                                        "questionType",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                value={row.totalMarks}
                                                                onChange={(e) =>
                                                                    handleInputChange(
                                                                        index,
                                                                        "totalMarks",
                                                                        e.target.value
                                                                    )
                                                                }
                                                            />
                                                        </td>
                                                        <td>
                                                            <button
                                                                type="button"
                                                                onClick={() => handleRowRemove(row.subject)}
                                                            >
                                                                ✖
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            )}

                            <label htmlFor="exam-details" className="exam_d">Exam Details:</label>
                            <textarea
                                id="exam-details"
                                value={examDetails}
                                onChange={(e) => setExamDetails(e.target.value)}
                                placeholder="Enter exam details"
                            ></textarea>
                            <label htmlFor="document-details" className="exam_d">Document Details:</label>
                            <input
                                type="file"
                                id="document-details"
                                onChange={handleFileInput}
                            />
                            <button type="submit" disabled={isSubmitDisabled}>
                                Create/Update Exam
                            </button>
                        </form>
                    </div>
                </div>
            )}
        </>
    );
}

export default FacultyCreateExamination;
